import { InjectionToken } from '@angular/core';

/**
 * Token used for providing the ILoginModuleConfig
 * @example
 * // in the app or shared modules providers section
 * providers: [
 *     { provide: EntityComponentsNotesModuleConfigToken, useValue: entityComponentsNotesModuleConfig },
 * ],
 */
const EntityComponentsNotesModuleConfigToken = new InjectionToken('entity_components_notes_module_config');

/**
 * Generated bundle index. Do not edit.
 */

export { EntityComponentsNotesModuleConfigToken };

//# sourceMappingURL=mt-ng2-entity-components-notes-config.js.map